import type { LayerKey } from '@festina-life/api'
import { useTranslate } from '@festina-life/ui/hooks'

import { useLayoutContext } from '../../../context/layoutContext'
import type { SubTemplateFieldValue } from '../../../types/templateModel'
import { TemplatePath } from '../../path/TemplatePath'
import { subTemplatedFieldValueDocumentation } from '../../templateFieldDocumentation/helpers'

type Props = {
  variant: SubTemplateFieldValue
  layer: LayerKey
  block: string
}

export const SubTemplatedFieldValueTitle = ({
  variant,
  block,
  layer,
}: Props) => {
  const translate = useTranslate()
  const variantDocumentation = subTemplatedFieldValueDocumentation(variant)
  const {
    preferences: { common },
  } = useLayoutContext()

  return (
    <div className="flex w-full flex-col gap-y-2">
      <div>
        <TemplatePath
          block={block}
          layer={layer}
          value={variant.path}
          className="text-sm"
          variant={common.isUsingModal ? 'contrast' : 'normal'}
          isInteractive
        />
      </div>
      <div className="flex gap-x-2">
        <div>{variantDocumentation?.modelFieldType}</div>
        {translate('templateViewer.details.title.templateVariant')}
      </div>
    </div>
  )
}
